export interface NumericDatatypeInterface extends Number {
  data?: number;
}

export class NumericDatatypeClass extends Number
  implements NumericDatatypeInterface {
  data?: number;
}
